// extracted by mini-css-extract-plugin
module.exports = {"portableText":"PostBody_portableText__Fbo7V"};